import { personal_details } from '@flows/configs/shared/steps/personal_details'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnySteps } from '@flows/core/types/stepTypes'

import birth_date from './birth_date'
import family_members from './familyMembers'
import tariff_selection from './tariff_selection'
import travel_quote from './travel_quote'

const getTravelHealthNxtSteps = (params: StepConfigParams) =>
  ({
    birth_date: birth_date(params),
    tariff_selection: tariff_selection(params),
    family_members: family_members(params),
    travel_quote: travel_quote(params),
    travel_health_personal_details: personal_details(params, {
      nextStep: 'gender',
      omitFields: ['birthdate'],
      policyPreviewConsent: {
        titleKey: 'sharedFlows_travelHealth:steps.personal_details.policyPreview.title',
        textKey: 'sharedFlows_travelHealth:steps.personal_details.policyPreview.text',
      },
      translations: {
        title: 'sharedFlows_common:steps.personal_details.title',
        birthdateLabel: 'sharedFlows_common:steps.personal_details.birthdate.input.label',
        marketingOptIn: 'sharedFlows_common:steps.email_and_name.checkboxes.marketingOptIn',
        minAgeError: 'sharedFlows_common:generic.errors.min_age',
        maxAgeError: 'sharedFlows_common:generic.errors.max_age',
      },
    }),
  }) as const satisfies AnySteps

export default getTravelHealthNxtSteps
